const getId = (rowData) => rowData.get('id');
const getValues = (rowData) => [...rowData.get('values')];

export {getId, getValues}